import { createRouter, createWebHistory } from 'vue-router';

import Default from '@/views/Layout/Default.vue';
import Login from '@/views/Login/Login.vue';
import Dashboard from '@/views/Dashboard/Dashboard.vue';
import CreateEditPH from '@/views/PH/CreateEditPH.vue';
import CreateEditWarehouse from '@/views/Warehouse/CreateEditWarehouse.vue';
import Challenges from '@/views/Challenges/Challenges.vue';
import PHDetails from '@/views/PH/PHDetails.vue';
import WarehouseDetails from '@/views/Warehouse/WarehouseDetails.vue';
import CreateEditAdmin from '@/views/Admin/CreateEditAdmin.vue';
import AdminArticlesList from '@/views/Articles/AdminArticlesList.vue';
import CreateEditArticleForm from '@/views/Articles/CreateEditArticleForm.vue';
import AdminQuiz from '@/views/Quiz/AdminQuiz.vue';
import CreateEitQuiz from '@/views/Quiz/CreateEitQuiz.vue';
import QuizSummary from '@/views/Quiz/QuizSummary.vue';
import PHArticlesList from '@/views/Articles/PHArticlesList.vue';
import PHQuizList from '@/views/Quiz/PHQuizList.vue';
import ArticlePreview from '@/views/Articles/ArticlePreview.vue';
import QuizAnswers from '@/views/Quiz/QuizAnswers.vue';
import Register from '@/views/Register/Register.vue';
import Withdraw from '@/views/Withdraw/Withdraw.vue';
import QuizAnswersSummary from '@/views/Quiz/QuizAnswersSummary.vue';
import { ROUTE_Dashboard } from '@/hooks/RouterHooks.ts';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login,
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
        },
        {
            path: '/',
            name: 'UserLogged',
            component: Default,
            children: [
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                },
                {
                    path: '/sales-rep/:id',
                    name: 'CreateEditPH',
                    component: CreateEditPH,
                },
                {
                    path: '/sales-rep/details/:id',
                    name: 'PHDetails',
                    component: PHDetails,
                },
                {
                    path: '/warehouse/:id',
                    name: 'CreateEditWarehouse',
                    component: CreateEditWarehouse,
                },
                {
                    path: '/challenges',
                    name: 'Challenges',
                    component: Challenges,
                },
                {
                    path: '/warehouse/details/:id',
                    name: 'WarehouseDetails',
                    component: WarehouseDetails,
                },
                {
                    path: '/admin/:id',
                    name: 'CreateEditAdmin',
                    component: CreateEditAdmin,
                },
                {
                    path: '/articles',
                    name: 'AdminArticlesList',
                    component: AdminArticlesList,
                },
                {
                    path: '/articles/:id',
                    name: 'CreateEditArticleForm',
                    component: CreateEditArticleForm,
                },
                {
                    path: '/quiz',
                    name: 'AdminQuiz',
                    component: AdminQuiz,
                },
                {
                    path: '/quiz/:id',
                    name: 'CreateEitQuiz',
                    component: CreateEitQuiz,
                },
                {
                    path: '/quiz/:id/summary',
                    name: 'QuizSummary',
                    component: QuizSummary,
                },
                // Routing PH - Powyzej wszystko poza dashboardem tyczy sie admina
                {
                    path: '/articles-ph',
                    name: 'PHArticlesList',
                    component: PHArticlesList,
                },
                {
                    path: '/quiz-ph',
                    name: 'PHQuizList',
                    component: PHQuizList,
                },
                {
                    path: `/articles-ph/:id`,
                    name: 'ArticlePreview',
                    component: ArticlePreview,
                },
                {
                    path: `/articles/preview/:id`,
                    name: 'ArticleAdminPreview',
                    component: ArticlePreview,
                },
                {
                    path: `/quiz-ph/:id`,
                    name: 'QuizAnswers',
                    component: QuizAnswers,
                },
                {
                    path: `/quiz-ph/summary`,
                    name: 'QuizAnswersSummary',
                    component: QuizAnswersSummary,
                },
                {
                    path: '/withdraw',
                    name: 'Withdraw',
                    component: Withdraw,
                },
            ],
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.name === ROUTE_Dashboard) {
            return {
                ...savedPosition,
                behavior: 'smooth'
            };
        }
        return { top: 0, behavior: 'smooth' };
    }
});

export default router;
